var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardCreditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 185,
    viewBox: "0 0 301 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10304_19079)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 185,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 185V0H300V185H0Z",
    fill: "url(#paint0_radial_10304_19079)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10304_19079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 214,
    height: 214
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.03 49.2561L132.256 49.0304C138.08 43.2063 147.47 43.2063 153.295 49.0304L160.834 56.57C166.658 62.3941 166.658 71.7848 160.834 77.6088L151.489 86.9544L151.443 86.9093L126.025 112.373L126.07 112.418L106.612 131.831L132.075 157.204L144.31 144.969L184.221 105.059L191.805 97.4738C208.646 80.6337 208.646 53.3194 191.805 36.4793L173.34 18.0139C156.5 1.17383 129.186 1.17383 112.346 18.0139L106.612 23.7477L132.03 49.2561Z",
    fill: "#00BFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7928 103.253L45.2109 77.8346L44.9852 77.6089C39.1611 71.7848 39.1611 62.3941 44.9852 56.57L52.5248 49.0304C58.3489 43.2063 67.7396 43.2063 73.5637 49.0304L82.9092 58.3759L82.8641 58.4211L108.282 83.8392L108.327 83.7941L127.786 103.253L153.204 77.8346L140.879 65.4641L100.968 25.5084L93.5189 18.1042C76.6789 1.26413 49.4097 1.26413 32.5696 18.1042L14.059 36.5696C-2.78107 53.4097 -2.78107 80.7241 14.059 97.5641L19.7928 103.253Z",
    fill: "#00BFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7894 164.608L73.5637 164.834C67.7396 170.658 58.3489 170.658 52.5248 164.834L44.9852 157.295C39.1611 151.47 39.1611 142.08 44.9852 136.256L54.3307 126.91L54.3759 126.955L79.794 101.537L79.7489 101.492L99.2076 82.0333L73.7894 56.6152L61.5544 68.8502L21.6438 108.761L14.059 116.346C-2.78107 133.186 -2.78107 160.455 14.059 177.295L32.5696 195.805C49.4097 212.646 76.724 212.646 93.5641 195.805L99.2978 190.072L73.7894 164.608Z",
    fill: "#00BFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 110.612L160.608 136.03L160.834 136.256C166.658 142.08 166.658 151.47 160.834 157.295L153.295 164.834C147.47 170.658 138.08 170.658 132.256 164.834L122.91 155.489L122.955 155.443L97.5372 130.025L97.492 130.07L78.0334 110.612L52.6152 136.03L64.8503 148.265L104.761 188.176L112.391 195.805C129.231 212.646 156.545 212.646 173.385 195.805L191.851 177.34C208.691 160.5 208.691 133.186 191.851 116.346L186.027 110.612Z",
    fill: "#00BFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10304_19079)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1,
    y: 0.0000915527,
    width: 300,
    height: 185,
    rx: 16,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10304_19079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 0,
    width: 214,
    height: 214
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.03 49.2561L131.256 49.0304C137.08 43.2063 146.47 43.2063 152.295 49.0304L159.834 56.57C165.658 62.3941 165.658 71.7848 159.834 77.6088L150.489 86.9544L150.443 86.9093L125.025 112.373L125.07 112.418L105.612 131.831L131.075 157.204L143.31 144.969L183.221 105.059L190.805 97.4738C207.646 80.6337 207.646 53.3194 190.805 36.4793L172.34 18.0139C155.5 1.17383 128.186 1.17383 111.346 18.0139L105.612 23.7477L131.03 49.2561Z",
    fill: "#00BFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 103.253L44.2109 77.8346L43.9852 77.6089C38.1611 71.7848 38.1611 62.3941 43.9852 56.57L51.5248 49.0304C57.3489 43.2063 66.7396 43.2063 72.5637 49.0304L81.9092 58.3759L81.8641 58.4211L107.282 83.8392L107.327 83.7941L126.786 103.253L152.204 77.8346L139.879 65.4641L99.9683 25.5084L92.5189 18.1042C75.6789 1.26413 48.4097 1.26413 31.5696 18.1042L13.059 36.5696C-3.78107 53.4097 -3.78107 80.7241 13.059 97.5641L18.7928 103.253Z",
    fill: "#00BFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7894 164.608L72.5637 164.834C66.7396 170.658 57.3489 170.658 51.5248 164.834L43.9852 157.295C38.1611 151.47 38.1611 142.08 43.9852 136.256L53.3307 126.91L53.3759 126.955L78.794 101.537L78.7489 101.492L98.2076 82.0333L72.7894 56.6152L60.5544 68.8502L20.6438 108.761L13.059 116.346C-3.78107 133.186 -3.78107 160.455 13.059 177.295L31.5696 195.805C48.4097 212.646 75.724 212.646 92.5641 195.805L98.2978 190.072L72.7894 164.608Z",
    fill: "#00BFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.027 110.612L159.608 136.03L159.834 136.256C165.658 142.08 165.658 151.47 159.834 157.295L152.295 164.834C146.47 170.658 137.08 170.658 131.256 164.834L121.91 155.489L121.955 155.443L96.5372 130.025L96.492 130.07L77.0334 110.612L51.6152 136.03L63.8503 148.265L103.761 188.176L111.391 195.805C128.231 212.646 155.545 212.646 172.385 195.805L190.851 177.34C207.691 160.5 207.691 133.186 190.851 116.346L185.027 110.612Z",
    fill: "#00BFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10304_19079)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0000915527,
    width: 300,
    height: 185,
    rx: 16,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10304_19079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.939 66.459) rotate(90) scale(175.048 178.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10304_19079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 185,
    rx: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCreditBlack);
export default __webpack_public_path__ + "static/media/card-credit-black.005858b832770f1e82b5632821f67d05.svg";
export { ForwardRef as ReactComponent };